import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetomalvancabservice() {



  const cardData = {
"keyword": "Pune to Malvan Cab Service",

"headingDescription":
  "Shivai Travels offers reliable and comfortable Pune to Malvan Cab Service for travelers seeking safe, affordable, and convenient coastal transportation. Whether you are planning a beach vacation, Sindhudurg fort visit, family trip, adventure tour, scuba diving experience, or peaceful Konkan getaway, our taxi service ensures a smooth and stress-free journey. With experienced drivers who are well-versed with ghats and Konkan coastal routes, clean air-conditioned vehicles maintained for long-distance comfort, and transparent pricing with no hidden charges, we provide a dependable travel experience from Pune to Malvan. Our fleet includes sedans, SUVs, Innova cars, and premium vehicles suitable for solo travelers, families, groups, and tourism trips. With flexible one-way and round-trip options, doorstep pickup from Pune, easy cab booking, and 24/7 customer support, Shivai Travels ensures a comfortable and scenic journey to one of Maharashtra’s most famous coastal and heritage destinations.",

"topPlaces": [
  {
    "title": "Sindhudurg Fort",
    "description":
      "Sindhudurg Fort is a historic sea fort built by Chhatrapati Shivaji Maharaj on an island near Malvan. It is known for its strong architecture, strategic importance, and breathtaking views of the Arabian Sea, making it the most iconic attraction in the region."
  },
  {
    "title": "Tarkarli Beach",
    "description":
      "Tarkarli Beach is one of the most famous beaches near Malvan known for its crystal-clear waters, white sand, and water sports activities like scuba diving and snorkeling. It is a top attraction for tourists traveling from Pune."
  },
  {
    "title": "Devbagh Beach",
    "description":
      "Devbagh Beach is known for its peaceful backwaters meeting the Arabian Sea, offering boat rides, dolphin spotting, and scenic natural beauty. It is a perfect destination for relaxation and photography."
  },
  {
    "title": "Malvan Town",
    "description":
      "Malvan is a vibrant coastal town famous for its seafood, local culture, and access to beaches and forts. It serves as the central hub for exploring Tarkarli, Sindhudurg Fort, and nearby attractions."
  },
  {
    "title": "Rock Garden Malvan",
    "description":
      "Rock Garden is a scenic seaside attraction in Malvan offering beautiful sunset views, rocky coastline formations, and a peaceful environment for visitors looking to relax and enjoy nature."
  },
  {
    "title": "Chivla Beach",
    "description":
      "Chivla Beach is a calm and less crowded beach near Malvan known for its clean shoreline, gentle waves, and peaceful surroundings, ideal for relaxation and evening walks."
  },
  {
    "title": "Dhamapur Lake",
    "description":
      "Dhamapur Lake is a serene freshwater lake surrounded by greenery near Malvan. It is perfect for nature lovers and offers a peaceful break from beach activities."
  },
  {
    "title": "Malvan Scuba Diving Point",
    "description":
      "Malvan is one of India’s popular scuba diving destinations, offering clear underwater visibility and rich marine life experiences, making it a major attraction for adventure seekers traveling from Pune."
  },
  {
    "title": "Kunkeshwar Temple",
    "description":
      "Kunkeshwar Temple is a famous coastal Shiva temple located near Malvan known for its spiritual importance and scenic sea-facing location."
  },
  {
    "title": "Konkan Coastal Scenic Route",
    "description":
      "The Pune to Malvan route passes through the Western Ghats, dense forests, ghats, tunnels, and lush Konkan landscapes. The journey is highly scenic, especially during monsoon, offering waterfalls, greenery, and coastal views that make the road trip memorable."
  }
],



services: [
  {
    name: "Pune to Malvan Cab",
    description: "Pune to Malvan cab service provides reliable transportation between Pune and Malvan with comfortable vehicles and experienced drivers. Vehicles are suitable for highway and coastal travel ensuring smooth and safe journeys for families, tourists, and beach holiday travelers. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals across Pune and Malvan. Vehicles include sedans, SUVs, Innova Crysta, Ertiga, and premium taxis suitable for different travel requirements. Flexible booking options allow convenient one-way and round-trip cab reservations."
  },
  {
    name: "Pune to Malvan Taxi",
    description: "Pune to Malvan taxi service offers dependable transportation for passengers traveling between Pune and Malvan with professional chauffeurs and comfortable vehicles. Vehicles provide spacious seating and smooth highway travel suitable for Konkan tourism, beach holidays, and family journeys. Professional drivers ensure punctual pickup and safe driving services throughout the journey. Pickup services are available from homes, hotels, offices, railway stations, and airport terminals across Pune and Malvan. Flexible booking options allow convenient taxi reservations."
  },
  {
    name: "Cab from Pune to Malvan",
    description: "Cab from Pune to Malvan service provides comfortable intercity transportation for passengers traveling for beach vacations, Konkan tourism, sightseeing, and family trips. Vehicles ensure reliable highway travel with experienced chauffeurs offering safe and smooth journeys through scenic coastal routes. Pickup services are available from residential areas, offices, hotels, railway stations, and airports across Pune and Malvan. Ideal for one-way and round-trip travel requirements. Flexible booking options allow convenient cab reservations."
  },
  {
    name: "Taxi from Pune to Malvan",
    description: "Taxi from Pune to Malvan service offers reliable transportation with comfortable vehicles and professional drivers for travel between Pune and Malvan. Vehicles provide smooth highway and coastal route travel suitable for tourism, sightseeing, beach holidays, and family trips. Professional drivers ensure safe driving and timely pickup services throughout the journey. Pickup services are available from homes, hotels, offices, railway stations, and airport terminals across Pune and Malvan. Flexible booking options allow easy taxi reservations."
  },
  {
    name: "Pune to Malvan Cab Service",
    description: "Pune to Malvan cab service provides dependable transportation solutions for passengers traveling between Pune and Malvan with comfortable vehicles and experienced chauffeurs. Vehicles are suitable for long-distance Konkan coastal travel ensuring safe and smooth journeys for individuals, families, and group travelers. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals across Pune and Malvan. Ideal for beach vacations, tourism, and holiday trips. Flexible booking options allow convenient cab reservations."
  },
  {
    name: "Pune to Malvan Taxi Fare",
    description: "Pune to Malvan taxi fare service provides transparent pricing information for passengers planning travel between Pune and Malvan. Travelers can estimate transportation costs based on vehicle type, travel distance, and trip requirements. Comfortable vehicles ensure smooth highway travel with professional drivers offering safe transportation services. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals across Pune and Malvan. Flexible booking options allow convenient fare estimation and taxi reservations."
  },
  {
    name: "Pune to Malvan One Way Cab",
    description: "Pune to Malvan one way cab service provides economical transportation for passengers traveling from Pune to Malvan without return travel requirements. Comfortable vehicles ensure smooth highway travel suitable for beach holidays, tourism, and family travel. Professional drivers ensure punctual pickup and safe driving services throughout the journey. Pickup services are available across Pune and Malvan including homes, hotels, offices, railway stations, and airports. Flexible booking options allow convenient one-way cab reservations."
  },
  {
    name: "Pune to Malvan Round Trip Taxi",
    description: "Pune to Malvan round trip taxi service offers convenient return transportation for passengers planning travel between Pune and Malvan. Comfortable vehicles provide smooth highway journeys with experienced drivers ensuring safe and reliable transportation services. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals across Pune and Malvan. Ideal for tourism, sightseeing, beach holidays, and family vacations. Flexible booking options allow convenient round-trip taxi reservations."
  },
  {
    name: "Pune to Malvan Cab Booking",
    description: "Pune to Malvan cab booking service allows passengers to reserve comfortable transportation between Pune and Malvan. Vehicles include sedans, SUVs, luxury cars, Innova Crysta, and premium taxis suitable for different passenger requirements. Professional drivers ensure safe driving and punctual pickup services throughout the journey. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals across Pune and Malvan. Flexible booking options allow instant and advance cab reservations."
  },
  {
    name: "Cheap Pune to Malvan Cab",
    description: "Cheap Pune to Malvan cab service provides affordable transportation between Pune and Malvan with comfortable vehicles and economical pricing. Vehicles ensure reliable highway travel suitable for Konkan holidays, family journeys, and beach tourism. Professional drivers ensure safe driving and timely pickup services throughout the trip. Pickup services are available from homes, hotels, offices, railway stations, and airports across Pune and Malvan. Flexible booking options allow convenient low-cost cab reservations."
  },
  {
    name: "Best Pune to Malvan Taxi",
    description: "Best Pune to Malvan taxi service offers premium transportation with comfortable vehicles and professional chauffeurs for smooth coastal travel. Vehicles provide spacious seating, luggage capacity, and reliable highway performance suitable for beach vacations, tourism, and family trips. Professional drivers ensure safe driving and punctual pickup services throughout the journey. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals across Pune and Malvan. Flexible booking options allow convenient taxi reservations."
  },
  {
    name: "Sedan Pune to Malvan Cab",
    description: "Sedan Pune to Malvan cab service offers economical and comfortable transportation for solo travelers, couples, and small families traveling between Pune and Malvan. Sedan vehicles provide smooth highway travel with comfortable seating and luggage space suitable for coastal journeys. Professional drivers ensure punctual pickup and safe driving services throughout the trip. Pickup services are available from homes, offices, hotels, railway stations, and airports across Pune and Malvan. Flexible booking options allow convenient sedan cab reservations."
  },
  {
    name: "SUV Pune to Malvan Taxi",
    description: "SUV Pune to Malvan taxi service provides spacious transportation for families and groups traveling between Pune and Malvan. SUV vehicles offer comfortable seating, luggage capacity, and smooth highway performance suitable for coastal vacations and family journeys. Professional chauffeurs ensure safe driving and timely pickup services throughout the journey. Pickup services are available from homes, hotels, offices, railway stations, and airport terminals across Pune and Malvan. Flexible booking options allow convenient SUV taxi reservations."
  },
  {
    name: "Innova Pune to Malvan Cab",
    description: "Innova Pune to Malvan cab service provides premium SUV transportation for passengers seeking comfortable and reliable Konkan travel. Innova vehicles offer spacious seating, smooth ride quality, and luggage space suitable for beach vacations, sightseeing, and family trips. Professional drivers ensure safe driving and punctual pickup services throughout the journey. Pickup services are available from homes, offices, hotels, railway stations, and airports across Pune and Malvan. Flexible booking options allow convenient Innova cab reservations."
  },
  {
    name: "Beach Cab Pune Malvan",
    description: "Beach cab Pune Malvan service offers dependable transportation for passengers traveling from Pune to the scenic beaches of Malvan. Comfortable vehicles ensure smooth highway and coastal travel suitable for beach holidays, sightseeing, water sports tourism, and family vacations. Professional chauffeurs ensure safe driving and reliable transportation services throughout the route. Pickup services are available from homes, hotels, offices, railway stations, and airports across Pune and Malvan. Flexible booking options allow convenient beach cab reservations."
  }
],

tableData: [
  ["Pune to Malvan Cab", "Pune to Malvan Taxi"],
  ["Cab from Pune to Malvan", "Taxi from Pune to Malvan"],
  ["Pune to Malvan Cab Service", "Pune to Malvan Taxi Fare"],
  ["Pune to Malvan One Way Cab", "Pune to Malvan Round Trip Taxi"],
  ["Pune to Malvan Cab Booking", "Cheap Pune to Malvan Cab"],
  ["Best Pune to Malvan Taxi", "Sedan Pune to Malvan Cab"],
  ["SUV Pune to Malvan Taxi", "Innova Pune to Malvan Cab"],
  ["Beach Cab Pune Malvan", "Pune to Malvan Cab Service"]
],


 whychoose: [
      {
        WhyChooseheading: "Reliable Pune to Velas Beach Cab Service",
        WhyChoosedescription: "Shivai Travels provides reliable Pune to Velas Beach cab service with professional drivers, comfortable vehicles, and punctual pickup for smooth and safe Konkan coastal travel."
      },
      {
        WhyChooseheading: "Affordable Pune to Velas Beach Taxi Fare",
        WhyChoosedescription: "Shivai Travels offers affordable Pune to Velas Beach cab pricing with transparent fare details and no hidden charges. Customers receive complete fare information before confirming their booking."
      },
      {
        WhyChooseheading: "24/7 Velas Beach Cab Availability",
        WhyChoosedescription: "Our Pune to Velas Beach cab service operates 24 hours a day for beach vacations, turtle festival visits, family tours, Konkan sightseeing, and emergency transportation requirements."
      },
      {
        WhyChooseheading: "Comfortable & Clean AC Cabs",
        WhyChoosedescription: "All taxis provided by Shivai Travels are fully air-conditioned, sanitized, and regularly maintained to provide comfortable long-distance travel experiences for passengers visiting Velas Beach."
      },
      {
        WhyChooseheading: "One Way & Round Trip Cab Booking",
        WhyChoosedescription: "Shivai Travels offers flexible travel options including one-way Pune to Velas Beach taxi service, round-trip bookings, Konkan sightseeing tours, and customized travel packages."
      },
      {
        WhyChooseheading: "Wide Range of Cab Vehicle Choices",
        WhyChoosedescription: "Customers can choose from sedan taxis, Ertiga, Innova, premium Innova Crysta vehicles, and Tempo Travellers suitable for couples, families, tourists, and group tours."
      },
      {
        WhyChooseheading: "Doorstep Pickup Across Pune",
        WhyChoosedescription: "Shivai Travels provides convenient pickup from homes, hotels, Pune Airport, railway stations, and all major Pune locations including Baner, Wakad, Hinjewadi, Kharadi, and Hadapsar."
      },
      {
        WhyChooseheading: "Experienced Drivers for Konkan Routes",
        WhyChoosedescription: "Our experienced drivers are familiar with Pune to Velas Beach coastal and ghat routes, ensuring safe driving, smooth travel, and timely arrival for every beach journey."
      }
    ]
  };

  const faqData = [
    { question: "What is Pune to Velas Beach cab service?", answer: "Pune to Velas Beach cab service provides comfortable taxi transportation between Pune and Velas Beach for beach holidays, turtle festival visits, and Konkan travel." },
    { question: "Is Pune to Velas Beach cab service available 24 hours?", answer: "Yes, Shivai Travels provides 24/7 Pune to Velas Beach cab service." },
    { question: "Which vehicles are available for Pune to Velas Beach travel?", answer: "Shivai Travels offers sedan taxis, Ertiga, Innova, Innova Crysta, and Tempo Travellers." },
    { question: "Can I book a one-way cab from Pune to Velas Beach?", answer: "Yes, customers can book one-way as well as round-trip Pune to Velas Beach taxi services." },
    { question: "Do you provide Velas Beach sightseeing taxi packages?", answer: "Yes, Shivai Travels provides Velas Beach sightseeing and customized Konkan travel packages." },
    { question: "Are all Pune to Velas Beach taxis air-conditioned?", answer: "Yes, all taxis are fully air-conditioned and maintained for comfortable long-distance travel." },
    { question: "Can I book Pune to Velas Beach cab service online?", answer: "Yes, customers can easily book Pune to Velas Beach cab service online or through phone booking." },
    { question: "Do you provide cabs for family and group travel?", answer: "Yes, Shivai Travels provides comfortable vehicles suitable for family tours and group travel." },
    { question: "Are Pune to Velas Beach cab fares transparent?", answer: "Yes, Shivai Travels provides affordable and transparent pricing without hidden charges." },
    { question: "Is advance booking available for Pune to Velas Beach cab service?", answer: "Yes, advance booking is available and recommended during turtle festival season, weekends, and holidays." }
  ];

  const testimonials = [
    {
      id: 1,
      name: "Mr. Rohit Patil",
      feedback:
        "Booked Pune to Velas Beach cab service with Shivai Travels. Comfortable vehicle, smooth Konkan journey, and excellent driver support.",
      rating: 5
    },
    {
      id: 2,
      name: "Mrs. Snehal Deshpande",
      feedback:
        "Excellent Pune to Velas Beach taxi service. Affordable pricing, clean cab, and wonderful beach travel experience.",
      rating: 5
    }
  ];


















  const Images = [
    { place: "/images/keyword/1.jpg", text: "Pune Outstation Cab Service", link: "Pune-Outstation-Cab-Service" },
    { place: "/images/keyword/2.jpg", text: "Pune Taxi Service", link: "Pune-Taxi-Service" },
    { place: "/images/keyword/3.jpg", text: "Pune Cab Booking", link: "Pune-Cab-Booking" },
    { place: "/images/keyword/4.jpg", text: "Best Cab Service in Pune", link: "Best-Cab-Service-in-Pune" },
    { place: "/images/keyword/5.jpg", text: "Outstation Taxi Service Pune", link: "Outstation-Taxi-Service-Pune" },
    { place: "/images/keyword/6.jpg", text: "Cheap Cabs in Pune", link: "Cheap-Cabs-in-Pune" },
    { place: "/images/keyword/7.jpg", text: "Pune Cab Fare", link: "Pune-Cab-Fare" },
    { place: "/images/keyword/8.jpg", text: "Corporate Cab Service Pune", link: "Corporate-Cab-Service-Pune" },
    { place: "/images/keyword/9.jpg", text: "Pune Airport Cab", link: "Pune-Airport-Cab" },
    { place: "/images/keyword/10.jpg", text: "Pune Railway Station Cab Service", link: "Pune-Railway-Station-Cab-Service" },
    { place: "/images/keyword/11.jpg", text: "Pune One Way Cab Service", link: "Pune-One-Way-Cab-Service" },
    { place: "/images/keyword/12.jpg", text: "Pune Local and Outstation Cab", link: "Pune-Local-and-Outstation-Cab" },
    { place: "/images/keyword/13.jpg", text: "Pune to Mumbai Cab", link: "Pune-to-Mumbai-Cab" },
    { place: "/images/keyword/14.jpg", text: "Pune to Mumbai Airport Cab", link: "Pune-to-Mumbai-Airport-Cab" },
    { place: "/images/keyword/15.jpg", text: "Pune to Nashik Cab Service", link: "Pune-to-Nashik-Cab-Service" },
    { place: "/images/keyword/16.jpg", text: "Pune to Nagpur Cab", link: "Pune-to-Nagpur-Cab" },
    { place: "/images/keyword/17.jpg", text: "Pune to Kolhapur Cab", link: "Pune-to-Kolhapur-Cab" },
    { place: "/images/keyword/18.jpg", text: "Pune to Solapur Cab Service", link: "Pune-to-Solapur-Cab-Service" },
    { place: "/images/keyword/19.jpg", text: "Pune to Ahmednagar Taxi", link: "Pune-to-Ahmednagar-Taxi" },
    { place: "/images/keyword/20.jpg", text: "Pune to Sangli Cab", link: "Pune-to-Sangli-Cab" },
    { place: "/images/keyword/21.jpg", text: "Pune to Satara Cab Service", link: "Pune-to-Satara-Cab-Service" },
    { place: "/images/keyword/22.jpg", text: "Pune to Jalgaon Cab Service", link: "Pune-to-Jalgaon-Cab-Service" },
    { place: "/images/keyword/23.jpg", text: "Pune to Dhule Cab Service", link: "Pune-to-Dhule-Cab-Service" },
    { place: "/images/keyword/24.jpg", text: "Pune to Thane Cab", link: "Pune-to-Thane-Cab" },
    { place: "/images/keyword/25.jpg", text: "Pune to Panvel Cab", link: "Pune-to-Panvel-Cab" },

  ];











const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Malvan Cab Service",
  "image": "https://shivaitravels.com/assets/images/pune-to-malvan-cab.jpg",
  "description": "Book Pune to Malvan cab service for safe and comfortable Konkan coastal travel. Shivai Travels offers affordable one-way and round-trip taxi booking with sedan, SUV, Innova, and luxury cab options available 24x7 for beach trips, scuba diving, forts, and family vacations.",
  "brand": {
    "@type": "Brand",
    "name": "Shivai Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "5471"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹12/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://shivaitravels.com/pune-to-malvan-cab"
  }
};







  return (
    <div>

<Helmet>
  <title>Pune to Malvan Cab Service | Konkan Beach Taxi Booking | +91 9689815477</title>

  <meta
    name="description"
    content="Book Pune to Malvan cab service for one-way and round trip travel. Affordable taxi options including sedan, SUV, Innova, and luxury cabs available 24x7 for Konkan beach trips, scuba diving, forts, and family vacations."
  />

  <meta
    name="keywords"
    content="pune to malvan cab, pune to malvan taxi, cab from pune to malvan, taxi from pune to malvan, pune to malvan cab service, pune to malvan taxi fare, pune to malvan one way cab, pune to malvan round trip taxi, pune to malvan cab booking, cheap pune to malvan cab, best pune to malvan taxi, sedan pune to malvan cab, suv pune to malvan taxi, innova pune to malvan cab, beach cab pune malvan"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


      <div className="breadcrumb-bar">
        <div className="container">
          <div className="row align-items-center text-center">
            <div className="col-md-12 col-12">
              <h2 className="breadcrumb-title text-white"> {cardData.keyword}</h2>

            </div>
          </div>
        </div>
      </div>













      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/62.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#3F1B0D', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Shivai Travels: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">

                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>

                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>


              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    {/* <div className="service-icon">
                      🚗
                    </div> */}
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Shivai Travels</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Shivai Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919689815477" className="pc-call">+91 9689815477</a>
                    </div>

                    <div className="pc-cta">
                    <a
  href="https://wa.me/919689815477?text=Welcome%20to%20Shivai%20Travels!%20%F0%9F%9A%8C%0AWe%20are%20happy%20to%20assist%20you%20with%20comfortable%20and%20safe%20travel%20services.%20Please%20let%20us%20know%20how%20we%20can%20help%20you."
  target="_blank"
  rel="noopener noreferrer"
  className="pc-whats"
>
  <i className="bi bi-whatsapp"></i> WhatsApp
</a>
                      <a href="tel:+919689815477" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@shivaitravels.com" className="pc-email">
                      booking@shivaitravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-geo-alt-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Shivai Travels</strong><br />
                      Shop no 1, Kamdhenu nagar, Guru mauli society, Vadgaon road, Near super bazar, Alandi, Pune 412105
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Punetomalvancabservice;